import React, { useEffect, useState } from 'react';

import Header from "../componentes/Header";
import {Row, Col} from 'react-bootstrap'
import Seccion from '../componentes/Seccion';


function Aviso() {


    return (
        <div>
            <Header></Header>

            <div className="base-page">
                <Seccion className="section pos-relative ovf-hidden" id="privacy-notice">

                    <div className="line">
                        <Row style={{paddingLeft:"10px"}}>
                            <Col md={12} style={{paddingBottom:"60px"}}>
                                <h2 className="title mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 fw-black fs-60">
                                    <p className="fw-light">INTEGRAL </p>
                                    PRIVACY NOTICE
                                </h2>
                            </Col>



                            <Col md={12}>
                                <p>
                                    <strong>
                                        1.- INTEGRAL PRIVACY NOTICE TRANSMISIÓN Y VISIÓN DIGITAL, S.A. DE C.V.
                                    </strong>
                                </p>
                            </Col>
                            
                            

                    

                            <Col md={12}>
                                <p>
                                    TRANSMISIÓN Y VISIÓN DIGITAL specifically undertakes to: (i) 
                                    Process the holders personal data only for the purposes set out 
                                    in this Notice (ii) observe the protection principles for personal 
                                    data of legality, consent, information, quality, purpose, loyalty, 
                                    proportionality and responsibility, as well as the duties of care and 
                                    confidentiality provided by Applicable Provisions on Personal Data , 
                                    and (iii) implement and maintain administrative, technical and physical 
                                    security measures to protect the holders personal data against damage, 
                                    loss, alteration, destruction or unauthorized use, access and processing.
                                </p>
                            </Col>



                            <Col md={12}>
                                <p>
                                    <strong>
                                        2.- RESPONSIBLE FOR PERSONAL DATA, NAME AND ADDRESS:
                                    </strong>
                                </p>
                            </Col>



                            <Col md={12}>
                                <p>
                                    Transmisión y Visión Digital is  domiciled in Jaime Balmes 11, Edificio E, 
                                    Mezzanine 1, Section C, Plaza Polanco, Colonia Los Morales Polanco, C.P. 11510, 
                                    Mayor Miguel Hidalgo, Mexico City.
                                </p>
                            </Col>

                            <Col md={12}>
                                <p>
                                    In compliance with the Applicable Provisions on Personal Data, the person whose 
                                    data are mentioned below has been appointed to the person responsible for 
                                    processing the holders requests of Transmisión y Visión Digital,  for the exercise 
                                    of their rights and to promote the protection of personal data within our organization -------.
                                </p>
                            </Col>



                            <Col md={12}>
                                <p>
                                    <strong>
                                        3.- PERSONAL DATA SUBJECT TO TREATMENT:
                                    </strong>
                                </p>
                            </Col>


                            <Col md={12}>
                                <p>
                                    Transmisión y Visión Digital collects the following 
                                    personal data, which will be strictly used for the 
                                    purposes set out in this Privacy Notice:
                                </p>
                            </Col>



                            <ol>
                                <Col md={12}><li><p>Ful name</p></li></Col>
                                <Col md={12}><li><p>Ful name</p></li></Col>
                                <Col md={12}><li><p>Email</p></li></Col>
                                <Col md={12}><li><p>Phone</p></li></Col>
                                <Col md={12}><li><p>Address</p></li></Col>
                                <Col md={12}><li><p>fficial identification</p></li></Col>
                                <Col md={12}><li><p>Proof of address</p></li></Col>
                                <Col md={12}><li><p>Fingerprint</p></li></Col>
                                <Col md={12}><li><p>Age</p></li></Col>
                                <Col md={12}><li><p>Sex</p></li></Col>
                                <Col md={12}><li><p>Ethnicity</p></li></Col>
                                <Col md={12}><li><p>Bank details</p></li></Col>
                                <Col md={12}><li><p>Voice recording</p></li></Col>
                            </ol>


                            <p>&nbsp;</p>


                            <Col md={12}>
                                <p>
                                    Remote or Local Communication is not used to collect personal 
                                    data that you hold automatically or simultaneously, such as 
                                    <em>cookies and/or bacons</em> through digital methods for transferring 
                                    and reading information such as Bluetooth.
                                </p>
                            </Col>


                            <p>&nbsp;</p>


                            <Col md={12}>
                                <p>
                                    <strong>
                                            4.-PURPOSES OF TREATMENT
                                    </strong>
                                </p>
                            </Col>



                            <Col md={12}>
                                <p>
                                    Transmisión y Visión Digital collects and uses personal data about 
                                    holders for the following main purposes:
                                </p>
                            </Col>



                            <ol>
                                <Col md={12}><li><p>User identification and authentication</p></li></Col>
                                <Col md={12}><li><p>Tokens and bank transactions</p></li></Col>
                            </ol>


                            <p>&nbsp;</p>


                            <Col md={12}>
                                <p>
                                    Your personal details are not processed for secondary purposes 
                                    such as data not directly related with visits to the offices.
                                </p>
                            </Col>



                            <Col md={12}>
                                <p>
                                    <strong>
                                        5. PERSONAL DATA TRANSFER:
                                    </strong>
                                </p>
                            </Col>



                            <Col>
                                <p>
                                    Transmisión y Visión Digital may transfer your personal data to the 
                                    following third parties:
                                </p>
                            </Col>



                            <ol>
                                <Col md={12}>
                                    <li>
                                        <p>
                                            Where the transfer is provided  by law or it is in favor of competent 
                                            authorities that require it in terms of applicable law or as part of a 
                                            judicial or administrative process where it is necessary to disclose your 
                                            personal information.    
                                        </p>
                                    </li>
                                </Col>

                                <Col md={12}>
                                    <li>
                                        <p>
                                            When transfer is necessary for medical or health prevention or treatment issues.
                                        </p>
                                    </li>
                                </Col>

                                <Col md={12}>
                                    <li>
                                        <p>
                                            Where the transfer is necessary under a contract that is in the user interest or 
                                            is necessary for the maintenance or fulfillment of the Transmisión y Visión 
                                            Digital relationship with the users.
                                        </p>
                                    </li>
                                </Col>

                                <Col>
                                    <li>
                                        <p>
                                            Where the transfer is necessary or legally enforceable for the 
                                            safeguarding of public interest.
                                        </p>
                                    </li>
                                </Col>


                                <Col>
                                    <li>
                                        <p>
                                            To subsidiaries, affiliates or other entities within our same 
                                            corporate group, which operate under the same internal processes and policies.
                                        </p>
                                    </li>
                                </Col>
                            </ol>

                        

                            <Col md={12}>
                                <p>
                                    To make this type of data transfers, your consent is not required because 
                                    it is allowed  in terms of the Law.
                                </p>
                            </Col>

                        

                            <Col md={12}>
                                <p>Transmisión y Visión Digital reserves the right to make modifications or 
                                    updates to the terms and conditions of this Notice, for the attention of 
                                    legislative changes, internal policies and new requirements for provising 
                                    or offering of services and market practices.
                                </p>
                            </Col>

                            <Col md={12}>
                                <p>
                                    Such modifications will be available to individuals visiting the 
                                    Transmisión y Visión Digital offices through the website. The Notice 
                                    shall include the date of the last update thereof.
                                </p>
                            </Col>



                            <Col md={12}>
                                <p>
                                    <strong>
                                        7.- PROCEDURE TO EXERCISE THE ARCO RIGHTS
                                    </strong>
                                </p>
                            </Col>


                        
                            <Col md={12}>
                                <p>
                                Holders visiting the Transmisión y Visión Digital offices, have the right to 
                                (i) access and know the details of the processing of Transmisión y Visión 
                                Digital(i) when they believe that they are not being used in accordance with 
                                the principles , applicable duties and obligations, or (iv) to complain about the 
                                processing of their data for specific purposes. These rights are known as ARCO Rights.
                                </p>
                            </Col>

                            <Col md={12}>
                                <p>
                                    For the exercise of your ARCO Rights please send the request to the email indicated in 
                                    Section 2 of this Notice. The application shall contain the following information and documentation:
                                </p>
                            </Col>

                            <Col md={12}>
                                    <p>
                                    Name and copy of valid official identification of the holder and/or his/her legal representative. 
                                    In the case of legal representative, it must be accompanied by the legal document which his 
                                    personality is credited. Documents must be scanned and attached to the email to verify their veracity.
                                </p>

                            </Col>

                            <Col md={12}>
                                <p>
                                    The clear and precise description of the personal data for which the ARCO Rights are seek, as well as 
                                    the right or rights to be exercised, which can be described in the text of the email or in a 
                                    scanned attached document. This document must be signed at the end of the document and rubriced on each page.
                                </p>
                            </Col>

                            <Col md={12}>
                                <p>
                                    Expressly indicate the desire to receive the Transmisión y Visión Digital reply to your 
                                    request via email, provided to us.
                                </p>
                            </Col>

                            <Col md={12}>
                                <p>
                                    Once the application to exercise ARCO Rights has been received by Transmisión y Visión Digital, 
                                    the respective reply will be issued, and the application will be processed within the time 
                                    limits established by the Law. In case the owner is not satisfied with such reply, may contact 
                                    Transmisión y Visión Digital immediately through the channels indicated, being at entire disposal 
                                    for any issue and concern. If no reply is received within the indicated period, Transmisión y 
                                    Visión Digital will understand in good faith that the owner is satisfied with the response.
                                </p>
                            </Col>

                            <Col md={12}>
                                <p>
                                    Acellation or opposition in the appropriate part.
                                </p>
                            </Col>


                            <Col md={12}>
                                <p>
                                    <strong>
                                        8.- RECOGNITION
                                    </strong>
                                </p>
                            </Col>

                            <Col md={12}>
                                <p>
                                    By providing your personal data, you consent the processing in the terms of 
                                    this Notice and with strict adherence to the Law, its Regulations and 
                                    the Applicable Provisions on Personal Data.
                                </p>
                            </Col>
                        </Row>
                    </div>


                </Seccion>
            </div>
    
        </div>
    );
}

export default Aviso